import React, { Component, createRef } from "react";
import * as s from "./DateRange.module.scss";
import { observer } from "mobx-react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  lowerRangeLabel: string;
  lowerRangePlaceholder: string;
  lowerRangeMax: number;
  upperRangeLabel: string;
  upperRangePlaceholder: string;
  upperRangeMax: number;
  onInputChange: any;
}

interface State {
  lowerRangeHasFocus: boolean;
  upperRangeHasFocus: boolean;
  lowerRangeValue: number;
}

@observer
export class DateRange extends Component<Props, State> {
  private lowerDateRangeRef = createRef<any>();
  private upperDateRangeRef = createRef<any>();

  constructor(props) {
    super(props);
    this.state = {
      lowerRangeValue: 0,
      lowerRangeHasFocus: false,
      upperRangeHasFocus: false
    };
  }

  onDateRangeInputChange = e => {
    const { onInputChange } = this.props;
    const { lowerDateRangeRef, upperDateRangeRef } = this;

    if (!e.target.min) {
      this.setState({ lowerRangeValue: e.target.value });
    }

    if (e.target.value.length > 4) {
      e.target.value = e.target.value.slice(0, 4);
    }

    if (e.target.value > e.target.max) {
      e.target.value = e.target.max;
    }

    if (e.target.min && e.target.value.length >= 4 && e.target.value < e.target.min) {
      e.target.value = parseInt(e.target.min) + 1;
    }

    const lowerDateRangeValue = lowerDateRangeRef && lowerDateRangeRef.current.value;
    const lowerDateRangeValueLength = lowerDateRangeValue.length;

    const upperDateRangeValue = upperDateRangeRef && upperDateRangeRef.current.value;
    const upperDateRangeValueLength = upperDateRangeValue.length;

    if (lowerDateRangeValueLength === 4 && upperDateRangeValueLength === 4) {
      onInputChange(parseInt(lowerDateRangeValue), parseInt(upperDateRangeValue));
    }
  };

  render() {
    const { lowerDateRangeRef, upperDateRangeRef } = this;
    const {
      lowerRangeLabel,
      lowerRangePlaceholder,
      lowerRangeMax,
      upperRangeLabel,
      upperRangePlaceholder,
      upperRangeMax,
      className
    } = this.props;

    const { lowerRangeValue, lowerRangeHasFocus, upperRangeHasFocus } = this.state;

    const lowerDateRangeValue =
      lowerDateRangeRef && lowerDateRangeRef.current && lowerDateRangeRef.current.value;

    const upperDateRangeValue =
      upperDateRangeRef && upperDateRangeRef.current && upperDateRangeRef.current.value;

    let inputFieldsContainerClasses = [s.inputFieldsContainer];
    let lowerRangeInputFieldClasses = [s.dateRangeInputField, s.lowerRangeInputField];
    let lowerRangeInputFieldLabelClasses = [
      s.inputFieldLabel,
      s.lowerRangeInputFieldLabel
    ];

    let upperRangeInputFieldClasses = [s.dateRangeInputField, s.upperRangeInputField];
    let upperRangeInputFieldLabelClasses = [
      s.inputFieldLabel,
      s.upperRangeInputFieldLabel
    ];

    if (className) inputFieldsContainerClasses.push(className);

    if ((lowerDateRangeValue && lowerDateRangeValue.length > 0) || lowerRangeHasFocus) {
      lowerRangeInputFieldClasses.push(s.hasValueOrFocus);
      lowerRangeInputFieldLabelClasses.push(s.hasValueOrFocus);
    }

    if ((upperDateRangeValue && upperDateRangeValue.length > 0) || upperRangeHasFocus) {
      upperRangeInputFieldClasses.push(s.hasValueOrFocus);
      upperRangeInputFieldLabelClasses.push(s.hasValueOrFocus);
    }

    return (
      <div className={s.inputFieldsContainer}>
        <div className={s.inputFieldWrapper}>
          <label
            className={lowerRangeInputFieldLabelClasses.join(" ")}
            htmlFor="lower-date-range-label"
          >
            {lowerRangeLabel}
          </label>
          <input
            ref={this.lowerDateRangeRef}
            id="lower-date-range-label"
            type="number"
            className={lowerRangeInputFieldClasses.join(" ")}
            placeholder={lowerRangePlaceholder}
            max={lowerRangeMax}
            onChange={this.onDateRangeInputChange}
            onFocus={() => this.setState({ lowerRangeHasFocus: true })}
          />
        </div>
        <hr className={s.inputFieldWrapperDivider} />
        <div className={s.inputFieldWrapper}>
          <label
            className={upperRangeInputFieldLabelClasses.join(" ")}
            htmlFor="upper-date-range-label"
          >
            {upperRangeLabel}
          </label>
          <input
            ref={this.upperDateRangeRef}
            id="upper-date-range-label"
            type="number"
            className={upperRangeInputFieldClasses.join(" ")}
            placeholder={upperRangePlaceholder}
            min={lowerRangeValue !== 0 ? lowerRangeValue : 1000}
            max={upperRangeMax}
            onChange={this.onDateRangeInputChange}
            onFocus={() => this.setState({ upperRangeHasFocus: true })}
          />
        </div>
      </div>
    );
  }
}
